import ProductSelection from "../../../domains2/orders/ProductSelection";
import appConfig from "../../../appconfig";
import { store } from "../../../store";
import { evaluateCustomerType } from "../../utils";
import { getProductSpecificDiscount } from "../../../domains2/priceRules/priceRulesHelpers";
import { convertProductSelectionsToMap } from "../../../domains2/orders/OrderLineMappingHelper";

const shouldShowDiscountPrice = (product, enableInGroupDiscount) => {
	return (product.discount && product.discount.options.discountScope !== "group") || product.discount && enableInGroupDiscount;
};

export const getProductPriceWithDiscounts = (
	products,
	productSelections,
	productCatalog,
	discountTypeDisable = ["familyDiscount"],
	enableInGroupDiscount = false
) => {
	// Early return for empty products
	if (!products || !products.length) return {};

	const storeGetters = store.getters;
	const featureToggles = storeGetters.featureToggles || {};
	const tenantData = storeGetters.tenantSpecificData;
	const userData = storeGetters.applicationUserData;

	const orderLinesContext = {
		channel: appConfig.channelAlias(),
		deliveryMethod: tenantData.deliveryChoice,
		customerType: evaluateCustomerType(),
		dailySpending: featureToggles.discountDailyLimit && userData && userData.meta ? userData.meta.dailySpending : undefined,
		enableProductBestPriceInCatalogAndCart: featureToggles.enableProductBestPriceInCatalogAndCart,
		cartProductsMap: convertProductSelectionsToMap(storeGetters.cartProducts)
	};

	const orderLines = ProductSelection.mapToOrderLinesGen(5)(
		productCatalog,
		productSelections,
		false,
		orderLinesContext,
		[],
		true,
		discountTypeDisable
	);

	// Relay on maps instead of arrays (and nested loops) for faster lookups
	const orderLinesMap = new Map();
	for (let i = 0; i < orderLines.length; i++) {
		const orderLine = orderLines[i];
		orderLinesMap.set(orderLine.productId, orderLine);
	}

	const result = {};

	for (let i = 0; i < products.length; i++) {
		const product = products[i];
		const productId = product.id;
		if (product.price) {
			// Handle products with direct price
			const discountValue = shouldShowDiscountPrice(product, enableInGroupDiscount)
				? getProductSpecificDiscount({ price: product.price, discount: product.discount })
				: 0;
			const basePrice = product.price;
			const discountPrice = discountValue > basePrice ? basePrice : basePrice - discountValue;
			result[productId] = { basePrice, discountPrice };
		} else {
			const orderLine = orderLinesMap.get(productId);
			if (orderLine) {
				result[productId] = {
					basePrice: orderLine.totalPriceBeforeAccum || orderLine.totalPrice,
					discountPrice: orderLine.totalPriceAccum
				};
			}
		}
	}
	return result;
};

export const UPSELL_FLOWS = Object.freeze({
	RCM_MARKETING_CARD: "rcmMarketingCard"
});

export const AUTH_FLOW_METHODS = Object.freeze({
	NORMAL: "normal",
	HISTORY: "history",
	CART: "cart",
	POPUP: "popup",
	QR: "QR",
	QR_NEW: "QR_NEW",
	AUTH_CODE: "auth_code"
});

export const AUTH_EVENT = Object.freeze({
	SIGN_UP: "sign_up",
	LOGIN: "login"
});

export const SUNSET_PLUS_UPSELL_MODAL_MINIMAL_SPENDING = 165;

export const getGlobalTemplateReplaceCssName = (tenantId, replaceCss) => {
	for (const key in replaceCss) {
		if (replaceCss[key].includes(tenantId)) {
			return key;
		}
	}
	return null;
};

export const generateRandomNumber = (max) => {
	return Math.floor(Math.random() * max);
};

export const extractShopContext = () => {
	const shop = store.getters.globalSelectedShop;
	const options = shop && shop.shopOptions;
	const stationData = options && options.dmiStationData;
	const stationId = stationData && stationData.id;

	const weatherData = options && options.shopWeatherData;
	const temperature = weatherData && weatherData.temperature;

	const shouldPushWeather =
	store.getters.featureToggles.enableWeatherSyncJob &&
	stationId &&
	weatherData &&
	temperature;

	return {
		shop,
		options,
		stationData,
		stationId,
		weatherData,
		temperature,
		shouldPushWeather
	};
};
